import { Component } from '@verndale/core';
import { animate, inView } from 'motion';

class ContentPodGroup extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      cards: this.el.querySelectorAll(
        '.content-pod-group__items > .content-pod-expand-card, .content-pod-group__items > .content-pod-icon, .content-pod-group__items > .content-pod-image'
      ) as NodeListOf<HTMLElement>
    };
    (this.dom.cards as NodeListOf<HTMLElement>).forEach(card => {
      card.style.opacity = '0';
    });
    this.setEqualHeights();
    if (window.innerWidth > 768) {
      this.animateCards();
    } else {
      (this.dom.cards as NodeListOf<HTMLElement>).forEach(card => {
        card.style.opacity = '1';
      });
    }
  }

  setEqualHeights() {
    const cards = this.dom.cards as NodeListOf<HTMLElement>;
    let maxHeight = 0;

    // Reset heights first
    cards.forEach(card => {
      card.style.blockSize = 'auto';
    });

    // Get the maximum height
    cards.forEach(card => {
      const height = card.offsetHeight;
      maxHeight = Math.max(maxHeight, height);
    });

    // Set all cards to the maximum height
    cards.forEach(card => {
      card.style.blockSize = `${maxHeight}px`;
    });
  }

  animateCards() {
    (this.dom.cards as NodeListOf<HTMLElement>).forEach(card => {
      inView(card, () => {
        animate(
          card,
          { opacity: [0, 1], scale: [0.5, 1] },
          {
            duration: 0.5,
            delay: 0.5
          }
        );
      });
    });
  }
}

export default ContentPodGroup;
